<template>
  <div>
    <div v-if="hospitals && hospitals.length > 0" class="dept">
      <a-carousel :dots="false" arrows>
        <div
          slot-scope="props"
          slot="prevArrow"
          class="custom-slick-arrow"
          style="left: 1080px;top:-50px;zIndex: 1"
          v-if="currPage - 1 > 0"
        >
          <a-icon @click="arrow(props)" type="left-circle" />
        </div>
        <div
          v-if="currPage - hospitalTotalPage < 0"
          slot-scope="props"
          slot="nextArrow"
          class="custom-slick-arrow"
          style="right: 10px;top:-50px"
        >
          <a-icon @click="arrow(props)" type="right-circle" />
        </div>
        <div v-for="(itme, index) in 2" :key="index">
          <div class="hp_flex">
            <div
              v-for="(obj, index1) in hospitals"
              :key="index1"
              class="tab_demo"
            >
              <div class="normal">
                <img v-if="obj.image" :src="base_url + obj.image" alt />
                <img v-else src="@/assets/default-img/dept.png" alt />
                <div>
                  <div class="detail">
                    <p>{{ obj.name }}</p>
                    <p>{{ obj.hospitalName }}</p>
                    <p class="txt">联系地址：{{ obj.address }}</p>
                  </div>
                </div>
              </div>
              <div class="guodu">
                <div class="detail">
                  <p>{{ obj.name }}</p>
                  <div class="line"></div>
                  <p>{{ obj.hospitalName }}</p>
                  <p>联系地址：{{ obj.address }}</p>
                </div>
                <div
                  @click="$toPage('/registered/dept/' + obj.id)"
                  class="guodu_registration"
                >
                  快速挂号
                </div>
              </div>
              <div class="registration">快速挂号</div>
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
    <noData v-else></noData>
  </div>
</template>
<script>
import { getDepts } from '@/api/index'
import noData from '@/components/NoData'
export default {
  components: {
    noData,
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 5,
      },
      hospitals: [],
      hospitalTotalPage: 1,
      currPage: 1,
    }
  },
  mounted() {
    this.initHospitals()
  },
  methods: {
    arrow(props) {
      console.log('props===', props)
      parseInt(props.key) == 1 ? this.form.pageNum++ : this.form.pageNum--

      this.initHospitals()
    },
    async initHospitals() {
      var res = await getDepts(this.form)
      this.hospitals = res.data.list || []
      this.hospitalTotalPage = res.data.totalPage || 1
      this.currPage = res.data.currPage
      console.log('res.data===', res.data)
    },
  },
}
</script>
<style lang="less">
.tab_demo {
  width: 228px;
  height: 352px;
  background: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 10px;
  overflow: hidden;
  position: relative;

  .normal {
    img {
      width: 228px;
      height: 183px;
    }
    .detail {
      padding-top: 11px;
      margin: 0 17px;
      p {
        font-size: 14px;
        color: #666666;
        margin-bottom: 8px;
      }
      p:nth-child(1) {
        color: #333333;
      }
    }
  }
  .registration,
  .guodu_registration {
    margin: 4px auto 0 auto;
    width: 128px;
    height: 32px;
    background: #ffffff;
    border: 2px solid #0079fe;
    border-radius: 10px;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0079fe;
    cursor: pointer;
  }
  .registration {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
  }
  .guodu {
    width: 228px;
    height: 0px;
    transition: all 0.5s;
    overflow: hidden;
    background: #0079fe;
    border-radius: 0px 0px 10px 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 99;
    .detail {
      p {
        text-align: center;
        margin-bottom: 12px;
        font-size: 13px;
        color: #fff;
      }
      .line {
        width: 25px;
        height: 2px;
        background: #ffffff;
        margin: 0 auto 20px auto;
      }
      p:nth-child(1) {
        margin-top: 21px;
        font-size: 14px;
      }
    }
  }
}
.tab_demo:hover .guodu {
  height: 228px;
}
.tab_demo:not(:last-child) {
  margin-right: 20px;
}
.txt {
  max-width: 100%;
  display: -webkit-box;
  color: #4d4d4d;
  line-height: 1.5;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; //多行请改这里，2表示最多2行，然后超出自显示省略号
}
.dept {
  /* For demo */
  .ant-carousel /deep/ .slick-slide {
    text-align: center;
    width: 25%;
    overflow: hidden;
  }

  .ant-carousel /deep/ .custom-slick-arrow {
    width: 27px;
    height: 27px;
    font-size: 27px;
    color: #999999;
    background-color: #fff;
    opacity: 0.4;
    border-radius: 50%;
  }
  .ant-carousel /deep/ .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel /deep/ .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .ant-carousel /deep/ .slick-slide h3 {
    color: #fff;
  }
  .ant-carousel .slick-prev:hover,
  .ant-carousel .slick-next:hover,
  .ant-carousel .slick-prev:focus,
  .ant-carousel .slick-next:focus {
    color: #999999;
    background-color: #fff;
  }
}
</style>
